
<div mat-dialog-title>Models cannot be imported<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button></div>
  <mat-dialog-content>    
    <div>
      <irb-inventory-grid
        [style.width] = "'100%'"
        [style.height] = "'240px'"
        [showSideBar] = "false"
        [gridOptions] = "gridOptions"
        [frameworkComponents] = 'frameworkComponents'
        [rowData] = 'data.invalidRecords'
        (gridReady) = "onGridReady($event)"></irb-inventory-grid>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button id="closeButton" (click)="close()" class="btn-medium-secondary">Cancel entire import</button>
    <button id="continueButton" (click)="completeImport()"
            [disabled]="!(data.newValidRecords?.length > 0 || data.existingValidRecords?.length > 0)"
            class="btn-medium-primary">Continue
    </button>
  </mat-dialog-actions>
